export const splitIntoChunks = <T>(arr: T[], chunkSize: number): Array<Array<T>> => {
  const chunks = [];
  for (let i = 0; i < arr.length; i += chunkSize) {
    chunks.push(arr.slice(i, i + chunkSize));
  }
  return chunks;
};
